import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=e5a20358&scoped=true"
import script from "./UserSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=e5a20358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a20358",
  null
  
)

export default component.exports